import React from "react";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";
import cn from "classnames";
import messages from "./affiliation-list-item-messages";
import { AFFILIATION_STATUS } from "../../../../constants";

import "./affiliation-list-item.scss";

const AffiliationListItem = ({
  customerName,
  expirationDate,
  intl,
  status
}) => {
  const formattedDate =
    expirationDate &&
    intl.formatDate(expirationDate, {
      year: "numeric",
      month: "long",
      day: "2-digit"
    });
  let message, isValid;
  switch (status) {
    case AFFILIATION_STATUS.EXPIRED:
      isValid = false;
      message = intl.formatMessage(messages.expiredAffiliation, {
        formattedDate
      });
      break;
    case AFFILIATION_STATUS.VALID:
      isValid = true;
      message = intl.formatMessage(messages.validAffiliation, {
        formattedDate
      });
      break;
    case AFFILIATION_STATUS.REAUTHORIZE:
    default:
      isValid = false;
      message = intl.formatMessage(messages.reauthorizeAffiliation);
      break;
  }

  const expirationDateClassNames = cn("affiliation-list-item__status-message", {
    "affiliation-list-item__status-message--invalid": !isValid
  });
  return (
    <li className="affiliation-list-item">
      <p className="affiliation-list-item__customer-name">{customerName}</p>
      <p className={expirationDateClassNames}>{message}</p>
    </li>
  );
};

const affiliationListItemPropType = {
  customerName: PropTypes.string.isRequired,
  expirationDate: PropTypes.number,
  status: PropTypes.oneOf(Object.values(AFFILIATION_STATUS)).isRequired
};

AffiliationListItem.propTypes = affiliationListItemPropType;

export { AffiliationListItem, affiliationListItemPropType };
export default injectIntl(AffiliationListItem);
